<template>
    <el-dialog :title="title" :visible.sync="open" width="1286px" @close="cancel" :close-on-click-modal="false">
    <ExchangeExhibitionForm :queryParams="queryParams" :handleQuery="this.handleQuery"
        :resetQuery="this.resetQuery" :applyDateListChange="applyDateListChange"/>
    <el-table 
    ref="singleTable"
    v-loading="loading" :data="exhibitionList" 
    @selection-change="handleSelectionChange" 
    @select-all="handleSelectionChangeAll"
    border stripe style="margin-top: 20px;">
          <el-table-column type="selection" width="55"  />
          <el-table-column label="展会编号" prop="exhibitionCode" width="100" :show-overflow-tooltip="true" />
          <el-table-column label="展会名称" prop="title" :show-overflow-tooltip="true" />
    </el-table>
    <Pagination  :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
        @pagination="getList" />

      <!-- 对话框底部按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
</template>

<script>
import ExchangeExhibitionForm from './components/ExchangeExhibitionForm.vue';
import {queryListPage,switchCurrentExhibitionApi} from "@/api/exhibitionList/index";
import Pagination from "@/components/Pagination";

export default {
    name: "ExchangeExhibitionDialog",
    components: {ExchangeExhibitionForm,Pagination},
    props: {
        open: {
            type: Boolean,
            required: true
        },
    },
    data() {
        return {
            title:"切换展会",
            showSearch: true,
            // 查询参数
            queryParams: {
              page: 1,
              pageSize: 10,
              exhibitionCode: undefined,
              exhibitionName: undefined,
            },
            exhibitionList: [],
            total: 0,
            loading: false,
            selectionItems: [],
        }
    },
    created() {
        console.log("ExchangeExhibitionDialog created")
        this.getList();
    },
    methods: {
        applyDateListChange(value) {
          console.log("applyDateListChange", value);
          this.queryParams.applyTimeStart = value[0];
          this.queryParams.applyTimeEnd = value[1];
          this.handleQuery();
        },
        /** 查询展会列表 */
        getList() {
          this.loading = true;
          const params = {
            ...this.queryParams,
          }
          queryListPage(params).then(response => {
            console.log("queryListPage==>", response)
            this.exhibitionList = response.data || [];
            this.total = response.count || 0;
            this.loading = false;
          }
          );
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
          this.selectionItems = selection;
          console.log("handleSelectionChange==>", selection)
          // 如果选中了多行，只保留最后一行
          if (selection.length > 1) {
            this.$refs.singleTable.clearSelection(); // 清空所有选中
            this.$refs.singleTable.toggleRowSelection(selection.pop()); // 选中最后一行
          }
   
        },
        handleSelectionChangeAll(selection) {
          console.log("handleSelectionChangeAll==>", selection)
          this.$refs.singleTable.clearSelection(); // 清空所有选中
        },

        submit() {
            if (this.selectionItems.length === 0) {
                this.$message.error("请选择展会");
                return;
            }else if(this.selectionItems.length > 1){
                this.$message.error("只能选择一个展会");
                return;
            }
            const exhibitionGuid = this.selectionItems[0].exhibitionGuid;
            const opt = new FormData();
            opt.append("exhibitionGuid", exhibitionGuid);
            switchCurrentExhibitionApi(opt).then(response => {
                this.$message.success("切换展会成功");
                this.$store.dispatch('user/setCurrentExhibitionName',this.selectionItems[0].title);
                localStorage.setItem("currentExhibitionGuid", response.guid);
                localStorage.setItem("currentExhibitionName", response.title);
                localStorage.setItem("exhibitionManageMethod", response.manageMethod || '0');
                this.$router.push({ path: "/exhibitionInfo/exhibitionInfo", query: { guid: exhibitionGuid } });
                this.$emit("submit");
            });
        },
        cancel() {
           
            this.$emit('cancel');
        },
        /** 搜索按钮操作 */
        handleQuery() {
          console.log("搜索按钮操作", this.queryParams)
          this.queryParams.page = 1;
          this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
          this.queryParams = {
            page: 1,
            pageSize: 10,
            exhibitionCode: undefined,
            exhibitionName: undefined,
          }
          this.handleQuery();
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
